module.exports = __webpack_public_path__ + "static/img/jiaotang.c9dc693.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/jiaotang.png
// module id = Fw37
// module chunks = 1